import { useTranslation } from 'react-i18next';

import { SkeletonLoader } from '../../../widgets/Skeletons';

import { WidgetType } from '../../../../shared/constants/widget';
import {
  HeroDimensionMetaData,
  WidgetDefinition,
} from '../../../../shared/types/widget';

import noInsights from '../../../../assets/OrgDim/no-insights.svg';
import { Typography } from '../../../widgets/Typography';

interface HeroDimensionProps {
  definition: WidgetDefinition;
  content: HeroDimensionMetaData;
}

function HeroDimension({ definition, content }: HeroDimensionProps) {
  const { t } = useTranslation();
  const { image: bannerImageUri } = content.data || {};

  const bannerImageUrl = import.meta.env.VITE_IMAGE_BASE_URL + bannerImageUri;

  return (
    <div className="grid items-center gap-x-4 gap-y-4 lg:flex">
      <img
        aria-hidden
        src={bannerImageUri ? bannerImageUrl : noInsights}
        className="max-w-[200px]"
        alt=""
      />
      <div className="flex flex-col gap-y-2">
        {content?.data && (
          <Typography variant="body-lg" className="b">
            {t('OVERVIEW')}
          </Typography>
        )}
        <Typography variant="display-sm" weight="semibold">
          {content?.data?.title ?? t('NO_INSIGHTS_AVAILABLE')}
        </Typography>
        <Typography variant="body-md" className="text-grey-800" as="p">
          {content?.data?.description ?? t('NO_INSIGHTS_AVAILABLE_DESCRIPTION')}
        </Typography>
      </div>
    </div>
  );
}

export default HeroDimension;
